import clsx from 'clsx'
import type { FoundingHexView } from 'lib/community/model'
import styles from './Badges.module.css'

/**
 * The two founding hexagons (design "Early Owner + Founding Member"): Early Owner is an outline
 * hexagon with its number "07" and "OF <cap>" (DealHunt's cap, `earlyOwnerCap`; no line without
 * one); Founding Member is ink with a blue edge, "MEMBER"
 * and "No. 03". Same size and clip-path as every other badge, so the grid stays aligned.
 * Decorative: the badge's name and DealHunt's line are the text beside it.
 */
const FoundingHex: React.VFC<{ view: FoundingHexView; className?: string }> = ({
  view,
  className,
}) => (
  <span
    className={clsx(
      styles.hex,
      view.kind === 'early' ? styles.badge_early : styles.badge_member,
      className
    )}
    aria-hidden="true"
  >
    <span className={clsx(styles.hexFill, styles.hexStack)}>
      {view.kind === 'early' ? (
        <>
          <span className={styles.hexEyebrow}>{'Early owner'}</span>
          {view.number && <span className={styles.hexNumber}>{view.number}</span>}
          {view.cap !== null && <span className={styles.hexSub}>{`of ${view.cap}`}</span>}
        </>
      ) : (
        <>
          <span className={styles.hexEyebrow}>{'Founding'}</span>
          <span className={styles.hexWord}>{'Member'}</span>
          {view.number && <span className={clsx(styles.hexSub, styles.hexNo)}>{view.number}</span>}
        </>
      )}
    </span>
  </span>
)

export default FoundingHex
